module.exports = __webpack_public_path__ + "fonts/Euclid Circular B Light.8ecee386.woff";